import ErrorIcon from '../assets/error.svg?raw'
import SuccessIcon from '../assets/success.svg?raw'

export class FeedbackService {
    private errorMessage: HTMLDivElement;
    private successMessage: HTMLDivElement;

    constructor(private containerElement: HTMLElement) {
        this.errorMessage = document.createElement("div")
        this.successMessage = document.createElement("div")
    }

    public showErrorMessage = (message: string) => {
        this.errorMessage.innerHTML = `${ErrorIcon} ${message}`;
        this.errorMessage.className = "message";
        this.errorMessage.style.backgroundColor = "#F55536";

        this.containerElement.appendChild(this.errorMessage)
    }

    public showSuccessMessage = (message: string) => {
        this.successMessage.innerHTML = `${SuccessIcon} ${message}`;
        this.successMessage.className = "message";
        this.successMessage.style.backgroundColor = "#9FC507";

        this.containerElement.appendChild(this.successMessage)
    }

    public hideMessages = () => {
        if (this.errorMessage) this.errorMessage.remove();
        if (this.successMessage) this.successMessage.remove();
    }

    public setButtonLoading = (button: HTMLButtonElement, loading: boolean, spinnerColor: string): void => {
        if (!button) return;

        if (loading) {
            const spinner = document.createElement('span');
            spinner.className = 'spinner';
            spinner.style.borderColor = spinnerColor;
            spinner.style.borderBottomColor = 'transparent';
            
            button.setAttribute('disabled', 'true');
            button.style.pointerEvents = 'none';
            
            // Store original text
            const originalText = button.textContent || '';
            button.setAttribute('data-original-text', originalText);
            
            // Clear button and add spinner + text
            button.innerHTML = '';
            button.appendChild(spinner);
            button.appendChild(document.createTextNode(originalText));
        } else {
            button.removeAttribute('disabled');
            button.style.pointerEvents = 'auto';
            
            // Restore original text
            const originalText = button.getAttribute('data-original-text') || '';
            button.innerHTML = originalText;
            button.removeAttribute('data-original-text');
        }
    }

    public setSubmitButtonLoading = (button: HTMLButtonElement, loading: boolean): void => {
        this.setButtonLoading(button, loading, "var(--white)");
    }

    public reloadPageWithTimeout(): void {
        setTimeout(() => {
            location.reload();
        }, 1000);
    }
}